import { Component, OnInit } from "@angular/core";
import { SmsDetail_Rep } from "src/classes/Automation/sms_detailreport";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { HttpService2 } from "src/app/services/Automation/http/http.service_smsReport";
import { User } from "src/classes/Automation/UserApp";
import { RepDates } from "src/classes/Automation/RepDates";
import { SmsMain_Rep } from "src/classes/Automation/sms_mainreport";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-childreport",
    templateUrl: "./childreport.component.html",
    styleUrls: ["./childreport.component.css"],
    providers: [HttpService2],
})
export class ChildreportComponent implements OnInit {
    user: User = new User();
    repdates: RepDates = new RepDates();
    receivedReport: SmsMain_Rep;
    smsdetail_reps: SmsDetail_Rep[];
    startFromReport: number = 0;

    constructor(
        private httpService2: HttpService2,
        private dynamicDialogService: DynamicDialogService,
        private logger: NGXLogger
    ) { }

    ngOnInit(): void {
        this.receivedReport = this.dynamicDialogService.getConfigData().report;

        this.user.useremail = sessionStorage.getItem("email");
        this.repdates.smsdatefrom = this.receivedReport.smsdate;
        this.repdates.smsdateto = this.receivedReport.smsdate;

        this.httpService2.getReportDetail(this.user, this.repdates)
            .subscribe((res: SmsDetail_Rep[]) => {
                this.smsdetail_reps = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    closeDialog(): void {
        this.dynamicDialogService.closeDialog();
    }
}
